const TestErrorLogger = () => {
  throw new Error("Congratulations! Raygun is set up and capturing errors");
  return null;
};

export default TestErrorLogger;
